export default {
    getWarehouses() {
        return ApiClient.get('/warehouses').then((response) => response.data.data);
    },
};
